import React, { createContext, useEffect, useState, useCallback } from "react";
import { getMyData } from "../api/auth";

let logoutTimer;

export const UserContext = createContext({
  token: "",
  isLoggedIn: false,
  userSet: () => {},
  user: undefined,
  logout: () => {},
  login: () => {},
});

const calculateRemainingTime = (expirationTime) => {
  const currentTime = new Date().getTime();
  const adjExpirationTime = new Date(expirationTime).getTime();

  return adjExpirationTime - currentTime;
};

const retrieveStoredToken = () => {
  const userToken = localStorage.getItem("RediHomeToken");
  const storedExpirationDate = localStorage.getItem("ExpirationTime");

  const remainingTime = calculateRemainingTime(storedExpirationDate);

  if (remainingTime <= 3600) {
    localStorage.removeItem("RediHomeToken");
    localStorage.removeItem("ExpirationTime");
    localStorage.removeItem("RediHomeUser");
    return null;
  }

  return {
    token: userToken,
    duration: remainingTime,
  };
};

const retrieveStoredUser = () => {
  const user = localStorage.getItem("RediHomeUser");

  return user;
};

const removeStoredUser = () => {
  localStorage.removeItem("RediHomeUser");
  return null;
};

export const getBoolStorage = (item) => {
  return localStorage.getItem(item) === "true";
};

export const UserProvider = (props) => {
  const tokenData = retrieveStoredToken();
  const userData = retrieveStoredUser();

  let initialToken;
  if (tokenData) {
    initialToken = tokenData.token;
  }
  let initialUser;
  if (userData) {
    initialUser = JSON.parse(userData);
  }

  const [token, setToken] = useState(initialToken);
  const [user, setUser] = useState(initialUser);

  const userIsLoggedIn = !!token;

  const logoutHandler = useCallback(() => {
    setToken(null);
    setUser(removeStoredUser());
    localStorage.removeItem("RediHomeToken");
    localStorage.removeItem("ExpirationTime");
    localStorage.removeItem("RediHomeUser");
    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
  }, []);

  const userSetHandler = async () => {
    let user = await getMyData(token);
    if (user?.isOk) {
      setUser(user.data);
      localStorage.setItem("RediHomeUser", JSON.stringify(user.data));
    }
  };

  const loginHandler = async (token, expirationTime) => {
    setToken(token);
    localStorage.setItem("RediHomeToken", token);
    localStorage.setItem("ExpirationTime", expirationTime);

    const remainingTime = calculateRemainingTime(expirationTime);

    logoutTimer = setTimeout(logoutHandler, remainingTime);
    try {
      let user = await getMyData(token);
      if (user.isOk) {
        setUser(user.data);
        localStorage.setItem("RediHomeUser", JSON.stringify(user.data));
      }
      return user?.data;
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    if (tokenData) {
      logoutTimer = setTimeout(logoutHandler, tokenData.duration);
    }
  }, [tokenData, logoutHandler]);

  const contextValue = {
    user: user,
    token: token,
    isLoggedIn: userIsLoggedIn,
    login: loginHandler,
    logout: logoutHandler,
    userSet: userSetHandler,
  };

  return (
    <UserContext.Provider value={contextValue}>
      {props?.children}
    </UserContext.Provider>
  );
};
